import { Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { Router, RouterLink, RouterLinkActive } from '@angular/router';
import {
	ItHeaderComponent,
	ItLanguageSwitcherComponent,
	ItNavBarItemComponent,
	ItButtonDirective,
	ItDropdownComponent,
	ItDropdownItemComponent,
	ItNavBarModule,
	AvailableLanguage,
	ItIconComponent,
} from 'design-angular-kit';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { IterlexService } from '../iterlex.service';
import type { Profile } from '../interfaces/profile';
import { environment } from '../../environments/environment';

@Component({
	selector: 'app-navbar',
	imports: [
		ItHeaderComponent,
		RouterLink,
		RouterLinkActive,
		ItLanguageSwitcherComponent,
		ItNavBarModule,
		ItNavBarItemComponent,
		ItDropdownComponent,
		ItDropdownItemComponent,
		ItButtonDirective,
		TranslateModule,
		ItIconComponent,
	],
	templateUrl: './navbar.component.html',
	styleUrl: './navbar.component.scss',
})
export class NavbarComponent {
	private router = inject(Router);
	private iterlexService = inject(IterlexService);
	private translateService = inject(TranslateService);

	@Input({ required: true }) set loginDisplay(loginDisplay: boolean) {
		if (loginDisplay) {
			this.iterlexService.getProfile().subscribe((profile) => {
				this.profile = profile;
				if (profile.roles.some((role) => role.name == 'Admin')) {
					this.isAdmin = true;
				}
			});
		}
		this.isLogged = loginDisplay;
	}
	@Output() login = new EventEmitter();
	@Output() logout = new EventEmitter();
	availableLanguages?: AvailableLanguage[];
	environment = environment;
	constructor() {
		this.translateService.addLangs(
			environment.availableLanguages.map((lang) => lang.code),
		);
		this.availableLanguages = environment.availableLanguages;
	}
	light = false;
	sticky = false;
	search = false;
	isLogged = false;
	profile!: Profile;
	isAdmin = false;
	goToLogin() {
		this.router.navigateByUrl('/login');
	}
	goToSearch() {
		this.router.navigateByUrl('/search');
	}
}
